import mapboxgl from 'mapbox-gl'

export const toggleLayer = (
  map: mapboxgl.Map,
  { id, visible }: { id: string; visible: boolean }
) => {
  map.setLayoutProperty(id, 'visibility', visible ? 'visible' : 'none')
}
export const toggleLayers = (
  map: mapboxgl.Map,
  { ids, visible }: { ids: string[]; visible: boolean }
) => {
  ids.forEach((id) => {
    const doit = () =>
      map.setLayoutProperty(id, 'visibility', visible ? 'visible' : 'none')
    map.once('idle', doit).once('moveend', doit).once('styledata', doit)
  })
}
export const executeWhenReady = (
  map: mapboxgl.Map,
  callback: (...args: any[]) => void
) => {
  map
    .once('styledata', callback)
    .once('moveend', callback)
    .once('idle', callback)
}
